$(document).ready(function () {

    var fitComplete = sessionStorage.getItem('_fit_finder_complete');

    if (!fitComplete) {
        // Get the step URL that the user came from
      var style = "";
      var mountType = "";
      var windowWidth = 0;
      var windowHeight = 0;
      var shadeExtension = 0;
      var shadeAboveWindow = 0;
      var rodInstalled = false;
      var insideMountWidth = 0;
      var insideMountHeight = 0;
      var outsideMountWidth = 0;
      var outsideMountHeight = 0;
      var goBack = sessionStorage.getItem('_pb_goback');
      var selectedOption = null;

      //Changed from using local storage to guess where the user was last, to using the referrer to check if they came directly from a drapes or shade product page.
      var prevURL = document.referrer;
      
      if (prevURL.includes('/products/')) {
        if (prevURL.includes('shade')) {
           selectedOption = 'shades';
          style = 'Shades';
        }
        else if (prevURL.includes('drape')) {
           selectedOption = 'drapes';
          style = "Drapery";
        }
      }
      
        // If we have a selectedOption, pre-select that product
        if (selectedOption != null) {
            sessionStorage.setItem('_fit_finder_style', selectedOption);

            $('.step1').hide();

            if (selectedOption === "drapes") {
              $('.go-back-drapes').fadeOut(100);
                $('.step2-drapes').fadeIn(400);

                // Scroll to the top of the window
                $("body").scrollTop(0);

                // Set loading bar default to 100%
                var bar1 = new ldBar(".ldBar", {
                    "stroke": '#078578',
                    "stroke-trail": '#ffffff',
                    "aspect-ratio": 'none',
                    "preset": 'line',
                    "value": 10,
                    "duration": 1,
                });

                bar1.set(25);

                // Rod installed or not installed
                $('.rod').change(function () {

                    // Set loading bar default to 35%
                    var bar1 = new ldBar(".ldBar", {
                        "stroke": '#078578',
                        "stroke-trail": '#ffffff',
                        "aspect-ratio": 'none',
                        "preset": 'line',
                        "value": 10,
                        "duration": 1,
                    });

                    bar1.set(35);

                    // Scroll to the top of the window
                    $("body").scrollTop(0);

                    var rodStatus = $('input[name=\'rod\']:checked').val();
                    sessionStorage.setItem('_fit_finder_rod_status', rodStatus);

                    // YES - Rod installed. Get rod length and height from bottom of rod to the floor
                    if (rodStatus === "true") {

                        $('.step2-drapes').fadeOut(400, function () {
                            $('.step3-drapes-rodtrue').fadeIn(400);
                        });


                        // Set loading bar default to 35%
                        var bar1 = new ldBar(".ldBar", {
                            "stroke": '#078578',
                            "stroke-trail": '#ffffff',
                            "aspect-ratio": 'none',
                            "preset": 'line',
                            "value": 10,
                            "duration": 1,
                        });

                        bar1.set(35);

                        $('.rod-measure-continue').click(function () {

                            var goBackStage = "step3-drapes-rodtrue";
                            sessionStorage.setItem('_fit_finder_panel_go_back', goBackStage);

                            var rodWidthInches = parseFloat($('.drapes-rod-width-inches option:selected').val()) || 0;
                            var rodWidthEighths = parseFloat($('.drapes-rod-width-eighths option:selected').val()) || 0;
                            var rodHeightInches = parseFloat($('.drapes-rod-height-inches option:selected').val()) || 0;
                            var rodHeightEighths = parseFloat($('.drapes-rod-height-eighths option:selected').val()) || 0;
                            var rodWidthTotal = rodWidthInches + rodWidthEighths;
                            var rodHeightTotal = rodHeightInches + rodHeightEighths;
                            sessionStorage.setItem('_fit_finder_rod_width', rodWidthTotal);
                            sessionStorage.setItem('_fit_finder_rod_height', rodHeightTotal);

                            $('.step3-drapes-rodtrue').fadeOut(400, function () {
                                $('.panelnumber-drapes').fadeIn(400);
                            });

                            // Scroll to the top of the window
                            $("body").scrollTop(0);

                            // Set loading bar default to 65%
                            var bar1 = new ldBar(".ldBar", {
                                "stroke": '#078578',
                                "stroke-trail": '#ffffff',
                                "aspect-ratio": 'none',
                                "preset": 'line',
                                "value": 10,
                                "duration": 1,
                            });

                            bar1.set(65);
                            $('.panels').change(function () {
                                var panelType = parseFloat($('input[name=\'panels\']:checked').val()) || 0;
                                sessionStorage.setItem('_fit_finder_panel_type', panelType);

                                // Scroll to the top of the window
                                $("body").scrollTop(0);

                                // Fall/drape style (Tailored, Lived In, Romantic)
                                $('.panelnumber-drapes').fadeOut(400, function () {
                                    $('.fallstyle-drapes').fadeIn(400);
                                });

                                // Set loading bar default to 75%
                                var bar1 = new ldBar(".ldBar", {
                                    "stroke": '#078578',
                                    "stroke-trail": '#ffffff',
                                    "aspect-ratio": 'none',
                                    "preset": 'line',
                                    "value": 10,
                                    "duration": 1,
                                });

                                bar1.set(75);

                                $('.fallstyle').change(function () {
                                    var fallStyle = $('input[name=\'fallstyle\']:checked').val();
                                    if (fallStyle === "tailored") {
                                        var fallMeasurement = -1;
                                    }
                                    if (fallStyle === "lived-in") {
                                        var fallMeasurement = 0;
                                    }
                                    if (fallStyle === "romantic") {
                                        var fallMeasurement = 1;
                                    }
                                    sessionStorage.setItem('_fit_finder_fall_style', fallStyle);
                                    sessionStorage.setItem('_fit_finder_fall_measurement', fallMeasurement);

                                    // CALCULATE SIZE AND DISPLAY SUMMARY
                                    // width per panel = length of the curtain rod/# of panels (single =1, Double = 2)
                                    // Panel height = Height of the curtain rod to the floor + How drapes will fall (-1, 0,  or 1)

                                    var panelWidth = rodWidthTotal/panelType;
                                    var panelHeight = rodHeightTotal + fallMeasurement;
                                    var width1 = firstNumber(panelWidth);
                                    var width2 = convertDecimal(panelWidth);
                                    var height1 = firstNumber(panelHeight);
                                    var height2 = convertDecimal(panelHeight);
                                    $('#inside-measurements').html(width1 + " " + width2 + '" Width x ' + height1 + " " + height2 + '" Height');
                                    $('.product-style').html(fallStyle);
                                    $('.product-type').html(style);

                                    // Set a local storage variable including the measurement finals
                                    sessionStorage.setItem('_fit_finder_final_width', panelWidth);
                                    sessionStorage.setItem('_fit_finder_final_height', panelHeight);

                                    // Scroll to the top of the window
                                    $("body").scrollTop(0);
                                    $('.fallstyle-drapes').fadeOut(400, function () {
                                        $('.summary').fadeIn(400);
                                    });


                                    // Set loading bar default to 100%
                                    var bar1 = new ldBar(".ldBar", {
                                        "stroke": '#078578',
                                        "stroke-trail": '#ffffff',
                                        "aspect-ratio": 'none',
                                        "preset": 'line',
                                        "value": 10,
                                        "duration": 1,
                                    });

                                    bar1.set(100);

                                    // Set the go back summary variable
                                    sessionStorage.setItem('_fit_finder_summary_goback', "fallstyle-drapes");

                                    // Set a local storage variable for completing a fit finder
                                    sessionStorage.setItem('_fit_finder_complete', "complete");

                                    // Grab the Go Back variables, and display depending on what they're set as. If they aren't set go to the collection for this product type
                                    var goBack = sessionStorage.getItem('_pb_goback');
                                    var goBackURL = sessionStorage.getItem('_pb_basepage');

                                    if (goBack === 'desktop-step-5-drapes') {
                                        $('.goback').html("<a type='button' class='fabric-choices call-to-action' href='" + goBackURL + "'>Continue With Your Custom Product</a>");
                                        // Set a Came From variable so we know what to show if we're going back to the product
                                        sessionStorage.setItem('_pb_camefrom', "fit-finder");
                                    }
                                    else if (goBack === 'mobile-measurements-readout') {
                                        $('.goback').html("<a type='button' class='fabric-choices call-to-action' href='" + goBackURL + "'>Continue to Customized Product</a>");
                                        // Set a Came From variable so we know what to show if we're going back to the product
                                        sessionStorage.setItem('_pb_camefrom', "fit-finder");
                                    }
                                    else {
                                        $('.goback').html("<a type='button' class='fabric-choices call-to-action' href='/collections/drapes/'>Customize Your Product</a>");
                                    }
                                });
                            });
                        });

                    }
                    // NO - Rod not installed. Get window width, inches beyond window rod to extend, height from window top to floor, and inches above frame to mount the rod
                    if (rodStatus === "false") {

                        // Scroll to the top of the window
                        $("body").scrollTop(0);

                        $('.step2-drapes').fadeOut(400, function () {
                            $('.step4-drapes-window').fadeIn(400);
                        });

                        // Set loading bar default to 100%
                        var bar1 = new ldBar(".ldBar", {
                            "stroke": '#078578',
                            "stroke-trail": '#ffffff',
                            "aspect-ratio": 'none',
                            "preset": 'line',
                            "value": 10,
                            "duration": 1,
                        });

                        bar1.set(35);
                        // Measure the width of your window, how far the drapes will extend on either side
                        $('.drapes-window-extension-continue').click(function () {

                            drapeWindowWidthInches = parseFloat($('.drapes-window-height option:selected').val()) || 0;
                            drapeWindowWidthEighths = parseFloat($('.drapes-window-height-eighths option:selected').val()) || 0;

                            drapeWindowWidthTotal = parseFloat(drapeWindowWidthInches) + parseFloat(drapeWindowWidthEighths);
                            sessionStorage.setItem('_fit_finder_drape_window_width', drapeWindowWidthTotal);

                            drapeWindowExtensionInches = $('.drapes-window-extension-inches option:selected').val() || 0;
                            drapeWindowExtensionEighths = $('.drapes-window-extension-eighths option:selected').val() || 0;


                            drapeWindowExtensionTotal = parseFloat(drapeWindowExtensionInches) + parseFloat(drapeWindowExtensionEighths);
                            sessionStorage.setItem('_fit_finder_drape_window_extension', drapeWindowExtensionTotal);

                            // Scroll to the top of the window
                            $("body").scrollTop(0);

                            // Fade in next step, then
                            $('.step4-drapes-window').fadeOut(400, function () {
                                $('.drapes-window-frameheight').fadeIn(400);
                            });

                            // Set loading bar default to 100%
                            var bar1 = new ldBar(".ldBar", {
                                "stroke": '#078578',
                                "stroke-trail": '#ffffff',
                                "aspect-ratio": 'none',
                                "preset": 'line',
                                "value": 10,
                                "duration": 1,
                            });

                            bar1.set(45);


                          $('.drapes-window-frame-continue').click(function () {
                            var goBackStage = 'drapes-window-frameheight';
                            sessionStorage.setItem('_fit_finder_panel_go_back', goBackStage);

                            // Measure from the top of the window frame to the floor
                            var drapeWindowTopInches = parseFloat($('.drapes-window-frame-height-inches option:selected').val()) || 0;
                            var drapeWindowTopEighths = parseFloat($('.drapes-window-frame-height-eighths option:selected').val()) || 0;
                            var drapeWindowTopTotal = parseFloat(drapeWindowTopInches) + parseFloat(drapeWindowTopEighths);
                            sessionStorage.setItem('_fit_finder_drape_window_top', drapeWindowTopTotal);

                            var rodMountHeightInches = parseFloat($('.drapes-rod-mount-height-inches option:selected').val()) || 0;
                            var rodMountHeightEighths = parseFloat($('.drapes-rod-mount-height-eighths option:selected').val()) || 0;
                            var rodMountHeightTotal = parseFloat(rodMountHeightInches) + parseFloat(rodMountHeightEighths);
                            sessionStorage.setItem('_fit_finder_rod_mount_height', rodMountHeightTotal);

                            // Scroll to the top of the window
                            $("body").scrollTop(0);

                            // Rod mount height
                            $('.drapes-window-frameheight').fadeOut(400, function () {
                              //$('.step3-drapes-rodfalse').fadeIn(400);
                              $('.panelnumber-drapes').fadeIn(400);
                            });

                            // Set loading bar default to 100%
                            var bar1 = new ldBar(".ldBar", {
                              "stroke": '#078578',
                              "stroke-trail": '#ffffff',
                              "aspect-ratio": 'none',
                              "preset": 'line',
                              "value": 10,
                              "duration": 1,
                            });

                            bar1.set(65);
                          });

                          $('.rod-mount-height-continue').click(function () {
                            var goBackStage = 'drapes-window-frameheight';
                            sessionStorage.setItem('_fit_finder_panel_go_back', goBackStage);

                            rodMountHeightInches = parseFloat($('.drapes-rod-mount-height-inches option:selected').val()) || 0;
                            rodMountHeightEighths = parseFloat($('.drapes-rod-mount-height-eighths option:selected').val()) || 0;
                            rodMountHeightTotal = parseFloat(rodMountHeightInches) + parseFloat(rodMountHeightEighths);
                            sessionStorage.setItem('_fit_finder_rod_mount_height', rodMountHeightTotal);

                            // Single or double panels?

                            // Scroll to the top of the window
                            $("body").scrollTop(0);

                            $('.step3-drapes-rodfalse').fadeOut(400, function () {
                              $('.panelnumber-drapes').fadeIn(400);
                            });

                            // Set loading bar default to 100%
                            var bar1 = new ldBar(".ldBar", {
                              "stroke": '#078578',
                              "stroke-trail": '#ffffff',
                              "aspect-ratio": 'none',
                              "preset": 'line',
                              "value": 10,
                              "duration": 1,
                            });

                            bar1.set(65);
                          });

                          $('.panels').change(function () {

                            var panelType = parseFloat($('input[name=\'panels\']:checked').val()) || 0;
                            sessionStorage.setItem('_fit_finder_panel_type', panelType);

                            // Scroll to the top of the window
                            $("body").scrollTop(0);

                            // Fall/drape style (Tailored, Lived In, Romantic)
                            $('.panelnumber-drapes').fadeOut(400, function () {
                              $('.fallstyle-drapes').fadeIn(400);
                            });

                            // Set loading bar default to 100%
                            var bar1 = new ldBar(".ldBar", {
                              "stroke": '#078578',
                              "stroke-trail": '#ffffff',
                              "aspect-ratio": 'none',
                              "preset": 'line',
                              "value": 10,
                              "duration": 1,
                            });

                            bar1.set(85);
                          });

                          $('.fallstyle').change(function () {
                            var fallStyle = $('input[name=\'fallstyle\']:checked').val();
                            var panelType = parseFloat($('input[name=\'panels\']:checked').val()) || 0;
                            if (fallStyle === "tailored") {
                              var fallMeasurement = -1;
                            }
                            if (fallStyle === "lived-in") {
                              var fallMeasurement = 0;
                            }
                            if (fallStyle === "romantic") {
                              var fallMeasurement = 1;
                            }
                            sessionStorage.setItem('_fit_finder_fall_style', fallStyle);
                            sessionStorage.setItem('_fit_finder_fall_measurement', fallMeasurement);

                            // CALCULATE SIZE AND DISPLAY SUMMARY
                            // Width per panel =  (Width of window + 2 X How far drapes will extend past the window) /# of panels (single =1, Double = 2)
                            // Panel Height = Height from top of window to the floor + height from top of window to where rod will be mounted + How  drapes will fall (-1, x`0, or 1)
                            
                            var drapeWindowTopTotal = parseFloat(sessionStorage.getItem('_fit_finder_drape_window_top'));
                            var drapeWindowWidthTotal = parseFloat(sessionStorage.getItem('_fit_finder_drape_window_width'));
                            var rodMountHeightTotal = parseFloat(sessionStorage.getItem('_fit_finder_rod_mount_height'));
                            var drapeWindowExtensionTotal = parseFloat(sessionStorage.getItem('_fit_finder_drape_window_extension'));
                            var panelWidth = ((drapeWindowWidthTotal + (2 * drapeWindowExtensionTotal))/panelType);
                            var panelHeight = drapeWindowTopTotal + rodMountHeightTotal + (fallMeasurement);
                            var width1 = firstNumber(panelWidth);
                            var width2 = convertDecimal(panelWidth);
                            var height1 = firstNumber(panelHeight);
                            var height2 = convertDecimal(panelHeight);

                            $('#inside-measurements').html(width1 + " " + width2 + '" Width x ' + height1 + " " + height2 + '" Height');
                            $('.product-style').html(fallStyle);
                            $('.product-type').html(style);

                            // Set a local storage variable including the measurement finals
                            sessionStorage.setItem('_fit_finder_final_width', panelWidth);
                            sessionStorage.setItem('_fit_finder_final_height', panelHeight);

                            // Scroll to the top of the window
                            $("body").scrollTop(0);
                            $('.fallstyle-drapes').fadeOut(400, function () {
                              $('.summary').fadeIn(400);
                            });

                            // Set loading bar default to 100%
                            var bar1 = new ldBar(".ldBar", {
                              "stroke": '#078578',
                              "stroke-trail": '#ffffff',
                              "aspect-ratio": 'none',
                              "preset": 'line',
                              "value": 10,
                              "duration": 1,
                            });

                            bar1.set(100);

                            // Set the go back summary variable
                            sessionStorage.setItem('_fit_finder_summary_goback', "fallstyle-drapes");

                            // Set a local storage variable for completing a fit finder
                            sessionStorage.setItem('_fit_finder_complete', "complete");

                            // Grab the Go Back variables, and display depending on what they're set as. If they aren't set go to the collection for this product type
                            var goBack = sessionStorage.getItem('_pb_goback');
                            var goBackURL = sessionStorage.getItem('_pb_basepage');

                            // Go back
                            if (goBack === 'desktop-step-5-drapes') {
                              $('.goback').html("<a type='button' class='fabric-choices call-to-action' href='" + goBackURL + "'>Continue to Customized Product</a>");
                              // Set a Came From variable so we know what to show if we're going back to the product
                              sessionStorage.setItem('_pb_camefrom', "fit-finder");
                            }
                            else if (goBack === 'mobile-measurements-readout') {
                              $('.goback').html("<a type='button' class='fabric-choices call-to-action' href='" + goBackURL + "'>Continue to Customized Product</a>");
                              // Set a Came From variable so we know what to show if we're going back to the product
                              sessionStorage.setItem('_pb_camefrom', "fit-finder");
                            }
                            else {
                              $('.goback').html("<a type='button' class='fabric-choices call-to-action' href='/collections/drapes/'>Customize Your Product</a>");
                            }
                          }); // Fall style
                        });

                    } // End no rod
                });
            }

            if (selectedOption === "shades") {
              $('.go-back-shades-mount').fadeOut(100);
                $('.step2-shades').fadeIn(400);

                // Scroll to the top of the window
                $("body").scrollTop(0);

                // Set loading bar default to 25%
                var bar1 = new ldBar(".ldBar", {
                    "stroke": '#078578',
                    "stroke-trail": '#ffffff',
                    "aspect-ratio": 'none',
                    "preset": 'line',
                    "value": 10,
                    "duration": 5,
                });
                bar1.set(25);

                // Inside or Outside mount
                $('.shades-mount').change(function () {
                    mountType = $('input[name=\'shades-mount\']:checked').val();
                    sessionStorage.setItem('_fit_finder_mountType', mountType);
                    // Inside Mount window width, height
                    if (mountType === "inside-mount") {
                        $('.step2-shades').fadeOut(400, function () {
                            $('.step3-shades-inside').fadeIn(400);
                        });

                        // Scroll to the top of the window
                        $("body").scrollTop(0);

                        // Set loading bar default to 50%
                        var bar1 = new ldBar(".ldBar", {
                            "stroke": '#078578',
                            "stroke-trail": '#ffffff',
                            "aspect-ratio": 'none',
                            "preset": 'line',
                            "value": 10,
                            "duration": 5,
                        });
                        bar1.set(50);

                        // Grab the width and height on "Continue"
                        $('.inside-measure-continue').click(function () {
                            insideMountWidthInches = parseFloat($('.shades-inside-width-inches option:selected').val()) || 0;
                            insideMountWidthEighths = parseFloat($('.shades-inside-width-eighths option:selected').val()) || 0;
                            insideMountHeightInches = parseFloat($('.shades-inside-height-inches option:selected').val()) || 0;
                            insideMountHeightEighths = parseFloat($('.shades-inside-height-eighths option:selected').val()) || 0;
                            insideMountWidth = insideMountWidthInches + insideMountWidthEighths;
                            insideMountHeight = insideMountHeightInches + insideMountHeightEighths;
                            sessionStorage.setItem('_fit_finder_width', insideMountWidth);
                            sessionStorage.setItem('_fit_finder_height', insideMountHeight);

                            // Set loading bar default to 100%
                            var bar1 = new ldBar(".ldBar", {
                                "stroke": '#078578',
                                "stroke-trail": '#ffffff',
                                "aspect-ratio": 'none',
                                "preset": 'line',
                                "value": 10,
                                "duration": 1,
                            });

                            bar1.set(100);

                            // Scroll to the top of the window
                            $("body").scrollTop(0);

                            // CALCULATE THE SIZE
                            // Shade Width = Width of the window
                            // Shade Height = height of the window

                            var width1 = firstNumber(insideMountWidth);
                            var width2 = convertDecimal(insideMountWidth);
                            var height1 = firstNumber(insideMountHeight);
                            var height2 = convertDecimal(insideMountHeight);
                            $('#inside-measurements').html(width1 + " " + width2 + '" Width x ' + height1 + " " + height2 + '" Height');
                            $('.product-style').html(mountType);
                            $('.product-type').html(style);

                            // Grab the Go Back variables, and display depending on what they're set as. If they aren't set go to the collection for this product type
                            var goBack = sessionStorage.getItem('_pb_goback');
                            var goBackURL = sessionStorage.getItem('_pb_basepage');
                            if (goBack === 'desktop-step-5-blinds') {
                                $('.goback').html("<a type='button' class='fabric-choices call-to-action' href='" + goBackURL + "'>Continue With Your Custom Product</a>");
                                // Set a Came From variable so we know what to show if we're going back to the product
                                sessionStorage.setItem('_pb_camefrom', "fit-finder");
                            }
                            else if (goBack === 'mobile-measurements-readout') {
                                $('.goback').html("<a type='button' class='fabric-choices call-to-action' href='" + goBackURL + "'>Continue to Customized Product</a>");
                                // Set a Came From variable so we know what to show if we're going back to the product
                                sessionStorage.setItem('_pb_camefrom', "fit-finder");
                            }
                            else {
                                $('.goback').html("<a type='button' class='fabric-choices call-to-action' href='/collections/roman-shades/'>Customize Your Product</a>");
                            }

                            $('.step3-shades-inside').fadeOut(400, function () {
                                $('.summary').fadeIn(400);
                            });

                            // Set a local storage variable including the measurement finals
                            sessionStorage.setItem('_fit_finder_final_width', insideMountWidth);
                            sessionStorage.setItem('_fit_finder_final_height', insideMountHeight);

                            // Set the go back summary variable
                            sessionStorage.setItem('_fit_finder_summary_goback', "step3-shades-inside");

                            // Set a local storage variable for completing a fit finder
                            sessionStorage.setItem('_fit_finder_complete', "complete");
                        }); // End inside mount function
                    } // End inside mount

                    // Outside Mount: Window width outer edge, extension left and right, window height outer edge, inches mounted above window
                    if (mountType === "outside-mount") {

                        // Scroll to the top of the window
                        $("body").scrollTop(0);
                        $('.step2-shades').fadeOut(400, function () {
                            $('.step3-shades-outside').fadeIn(400);
                        });

                        // Set loading bar default to 50%
                        var bar1 = new ldBar(".ldBar", {
                            "stroke": '#078578',
                            "stroke-trail": '#ffffff',
                            "aspect-ratio": 'none',
                            "preset": 'line',
                            "value": 10,
                            "duration": 1,
                        });

                        bar1.set(50);
                        // Grab the width and height on "Continue"
                        $('.outside-measure-continue').click(function () {

                            // Scroll to the top of the window
                            $("body").scrollTop(0);
                            outsideMountWidthInches = parseFloat($('.shades-outside-width-inches option:selected').val()) || 0;
                            outsideMountWidthEighths = parseFloat($('.shades-outside-width-eighths option:selected').val()) || 0;
                            outsideExtension = parseFloat($('.shades-outside-extension-inches option:selected').val()) || 0;
                            outsideExtensionEighths = parseFloat($('.shades-outside-extension-eighths option:selected').val()) || 0;
                            outsideMountWidth = outsideMountWidthInches + outsideMountWidthEighths;
                            outsideExtensionTotal = outsideExtension + outsideExtensionEighths;
                            sessionStorage.setItem('_fit_finder_width', outsideMountWidth);
                            sessionStorage.setItem('_fit_finder_extension', outsideExtensionTotal);

                            $('.step3-shades-outside').fadeOut(400, function () {
                                $('.step4-shades-outside').fadeIn(400);
                            });

                            // Now show the final step, which is determining extension left and right, and inches mounted above window
                            // Set loading bar default to 75%
                            var bar1 = new ldBar(".ldBar", {
                                "stroke": '#078578',
                                "stroke-trail": '#ffffff',
                                "aspect-ratio": 'none',
                                "preset": 'line',
                                "value": 10,
                                "duration": 1,
                            });

                            bar1.set(75);


                            $('.outside-additional-continue').click(function () {

                                // Scroll to the top of the window
                                $("body").scrollTop(0);
                                outsideMountHeightInches = parseFloat($('.shades-outside-height-inches option:selected').val()) || 0;
                                outsideMountHeightEighths = parseFloat($('.shades-outside-height-eighths option:selected').val()) || 0;
                                outsideMountAbove = parseFloat($('.shades-outside-mount-height-inches option:selected').val()) || 0;
                                outsideMountAboveEighths = parseFloat($('.shades-outside-mount-height-eighths option:selected').val()) || 0;
                                outsideMountHeight = outsideMountHeightInches + outsideMountHeightEighths;
                                outsideMountTotal = outsideMountAbove + outsideMountAboveEighths;
                                sessionStorage.setItem('_fit_finder_height', outsideMountHeight);
                                sessionStorage.setItem('_fit_finder_mountTotal', outsideMountTotal);

                                // Grab the Go Back variables, and display depending on what they're set as. If they aren't set go to the collection for this product type
                                var goBack = sessionStorage.getItem('_pb_goback');
                                var goBackURL = sessionStorage.getItem('_pb_basepage');

                                if (goBack === 'desktop-step-5-blinds') {
                                    $('.goback').html("<a type='button' class='fabric-choices call-to-action' href='" + goBackURL + "'>Customize Your Product</a>");
                                    // Set a Came From variable so we know what to show if we're going back to the product
                                    sessionStorage.setItem('_pb_camefrom', "fit-finder");
                                }
                                else if (goBack === 'mobile-measurements-readout') {
                                    $('.goback').html("<a type='button' class='fabric-choices call-to-action' href='" + goBackURL + "'>Continue to Customized Product</a>");
                                    // Set a Came From variable so we know what to show if we're going back to the product
                                    sessionStorage.setItem('_pb_camefrom', "fit-finder");
                                }
                                else {
                                    $('.goback').html("<a type='button' class='fabric-choices call-to-action' href='/collections/roman-shades/'>Customize Your Product</a>");
                                }

                                $('.step4-shades-outside').fadeOut(400, function () {
                                    $('.summary').fadeIn(400);
                                });

                                // Set loading bar default to 100%
                                var bar1 = new ldBar(".ldBar", {
                                    "stroke": '#078578',
                                    "stroke-trail": '#ffffff',
                                    "aspect-ratio": 'none',
                                    "preset": 'line',
                                    "value": 10,
                                    "duration": 1,
                                });

                                bar1.set(100);

                                // CALCULATE THE SIZE FOR THE SUMMARY
                                // Shade Width = Width of the window + 2 X How far shade will extend past window frame
                                // Shade Height = Height of window + How far above window the shade will be mounted
                                var shadeWidth = outsideMountWidth + (2 * outsideExtensionTotal);
                                var shadeHeight = outsideMountHeight + outsideMountTotal;
                                var width1 = firstNumber(shadeWidth);
                                var width2 = convertDecimal(shadeWidth);
                                var height1 = firstNumber(shadeHeight);
                                var height2 = convertDecimal(shadeHeight);

                                $('#inside-measurements').html(width1 + " " + width2 + '" Width x ' + height1 + " " + height2 + '" Height');
                                $('.product-style').html(mountType);
                                $('.product-type').html(style);

                                // Set a local storage variable including the measurement finals
                                sessionStorage.setItem('_fit_finder_final_width', shadeWidth);
                                sessionStorage.setItem('_fit_finder_final_height', shadeHeight);

                                // Set the go back summary variable
                                sessionStorage.setItem('_fit_finder_summary_goback', "step4-shades-outside");

                                // Set a local storage variable for completing a fit finder
                                sessionStorage.setItem('_fit_finder_complete', "complete");
                            }); // End final step/show summary
                        });
                    } // End outside mount
                }); // End shade mount function
            }
        }

        if (selectedOption === null) {
            $('.step1').fadeIn(800);

            // Set loading bar default to 10%
            var bar1 = new ldBar(".ldBar", {
                "stroke": '#078578',
                "stroke-trail": '#ffffff',
                "aspect-ratio": 'none',
                "preset": 'line',
                "value": 10,
                "duration": 1,
            });

            bar1.set(10);

            // Style selected -- log the style choice, show step 2
            $('.style').change(function () {
                style = $('input[name=\'style\']:checked').val();
                sessionStorage.setItem('_fit_finder_style', style);

                // ROMAN SHADES
                if (style === "shades") {

                    $('.step1').fadeOut(400, function () {
                        $('.step2-shades').fadeIn(400);
                    });

                    // Scroll to the top of the window
                    $("body").scrollTop(0);

                    // Set loading bar default to 25%
                    var bar1 = new ldBar(".ldBar", {
                        "stroke": '#078578',
                        "stroke-trail": '#ffffff',
                        "aspect-ratio": 'none',
                        "preset": 'line',
                        "value": 10,
                        "duration": 5,
                    });
                    bar1.set(25);

                    // Inside or Outside mount
                    $('.shades-mount').change(function () {
                        mountType = $('input[name=\'shades-mount\']:checked').val();
                        sessionStorage.setItem('_fit_finder_mountType', mountType);

                        // Inside Mount window width, height
                        if (mountType === "inside-mount") {

                            $('.step2-shades').fadeOut(400, function () {
                                $('.step3-shades-inside').fadeIn(400);
                            });

                            // Scroll to the top of the window
                            $("body").scrollTop(0);

                            // Set loading bar default to 50%
                            var bar1 = new ldBar(".ldBar", {
                                "stroke": '#078578',
                                "stroke-trail": '#ffffff',
                                "aspect-ratio": 'none',
                                "preset": 'line',
                                "value": 10,
                                "duration": 5,
                            });
                            bar1.set(50);

                            // Grab the width and height on "Continue"
                            $('.inside-measure-continue').click(function () {
                                insideMountWidthInches = parseFloat($('.shades-inside-width-inches option:selected').val()) || 0;
                                insideMountWidthEighths = parseFloat($('.shades-inside-width-eighths option:selected').val()) || 0;
                                insideMountHeightInches = parseFloat($('.shades-inside-height-inches option:selected').val()) || 0;
                                insideMountHeightEighths = parseFloat($('.shades-inside-height-eighths option:selected').val()) || 0;
                                insideMountWidth = insideMountWidthInches + insideMountWidthEighths;
                                insideMountHeight = insideMountHeightInches + insideMountHeightEighths;
                                sessionStorage.setItem('_fit_finder_width', insideMountWidth);
                                sessionStorage.setItem('_fit_finder_height', insideMountHeight);

                                // Set loading bar default to 100%
                                var bar1 = new ldBar(".ldBar", {
                                    "stroke": '#078578',
                                    "stroke-trail": '#ffffff',
                                    "aspect-ratio": 'none',
                                    "preset": 'line',
                                    "value": 10,
                                    "duration": 1,
                                });

                                bar1.set(100);

                                // Scroll to the top of the window
                                $("body").scrollTop(0);

                                // CALCULATE THE SIZE
                                // Shade Width = Width of the window
                                // Shade Height = height of the window
                                var width1 = firstNumber(insideMountWidth);
                                var width2 = convertDecimal(insideMountWidth);
                                var height1 = firstNumber(insideMountHeight);
                                var height2 = convertDecimal(insideMountHeight);
                                $('#inside-measurements').html(width1 + " " + width2 + '" Width x ' + height1 + " " + height2 + '" Height');
                                $('.product-style').html(mountType);
                                $('.product-type').html(style);

                                // Grab the Go Back variables, and display depending on what they're set as. If they aren't set go to the collection for this product type
                                var goBack = sessionStorage.getItem('_pb_goback');
                                var goBackURL = sessionStorage.getItem('_pb_basepage');
                                if (goBack === 'desktop-step-5-blinds') {
                                    $('.goback').html("<a type='button' class='fabric-choices call-to-action' href='" + goBackURL + "'>Customize Your Product</a>");
                                    // Set a Came From variable so we know what to show if we're going back to the product
                                    sessionStorage.setItem('_pb_camefrom', "fit-finder");
                                } else {
                                    $('.goback').html("<a type='button' class='fabric-choices call-to-action' href='/collections/roman-shades/'>Customize Your Product</a>");
                                }

                                $('.step3-shades-inside').fadeOut(400, function () {
                                    $('.summary').fadeIn(400);
                                });

                                // Set a local storage variable including the measurement finals
                                sessionStorage.setItem('_fit_finder_final_width', insideMountWidth);
                                sessionStorage.setItem('_fit_finder_final_height', insideMountHeight);

                                // Set the go back summary variable
                                sessionStorage.setItem('_fit_finder_summary_goback', "step3-shades-inside");

                                // Set a local storage variable for completing a fit finder
                                sessionStorage.setItem('_fit_finder_complete', "complete");
                            }); // End inside mount function
                        } // End inside mount

                        // Outside Mount: Window width outer edge, extension left and right, window height outer edge, inches mounted above window
                        if (mountType === "outside-mount") {
                            // Scroll to the top of the window
                            $("body").scrollTop(0);

                            $('.step2-shades').fadeOut(400, function () {
                                $('.step3-shades-outside').fadeIn(400);
                            });

                            // Set loading bar default to 50%
                            var bar1 = new ldBar(".ldBar", {
                                "stroke": '#078578',
                                "stroke-trail": '#ffffff',
                                "aspect-ratio": 'none',
                                "preset": 'line',
                                "value": 10,
                                "duration": 1,
                            });

                            bar1.set(50);

                            // Grab the width and height on "Continue"
                            $('.outside-measure-continue').click(function () {
                                // Scroll to the top of the window
                                $("body").scrollTop(0);
                                outsideMountWidthInches = parseFloat($('.shades-outside-width-inches option:selected').val()) || 0;
                                outsideMountWidthEighths = parseFloat($('.shades-outside-width-eighths option:selected').val()) || 0;
                                outsideMountHeightInches = parseFloat($('.shades-outside-height-inches option:selected').val()) || 0;
                                outsideMountHeightEighths = parseFloat($('.shades-outside-height-eighths option:selected').val()) || 0;
                                outsideMountWidth = outsideMountWidthInches + outsideMountWidthEighths;
                                outsideMountHeight = outsideMountHeightInches + outsideMountHeightEighths;
                                sessionStorage.setItem('_fit_finder_width', outsideMountWidth);
                                sessionStorage.setItem('_fit_finder_height', outsideMountHeight);

                                $('.step3-shades-outside').fadeOut(400, function () {
                                    $('.step4-shades-outside').fadeIn(400);
                                });

                                // Now show the final step, which is determining extension left and right, and inches mounted above window
                                // Set loading bar default to 75%
                                var bar1 = new ldBar(".ldBar", {
                                    "stroke": '#078578',
                                    "stroke-trail": '#ffffff',
                                    "aspect-ratio": 'none',
                                    "preset": 'line',
                                    "value": 10,
                                    "duration": 1,
                                });

                                bar1.set(75);

                                $('.outside-additional-continue').click(function () {
                                    // Scroll to the top of the window
                                    $("body").scrollTop(0);
                                    outsideExtension = parseFloat($('.shades-outside-extension-inches option:selected').val()) || 0;
                                    outsideExtensionEighths = parseFloat($('.shades-outside-extension-eighths option:selected').val()) || 0;
                                    outsideMountAbove = parseFloat($('.shades-outside-mount-height-inches option:selected').val()) || 0;
                                    outsideMountAboveEighths = parseFloat($('.shades-outside-mount-height-eighths option:selected').val()) || 0;
                                    outsideExtensionTotal = outsideExtension + outsideExtensionEighths;
                                    outsideMountTotal = outsideMountAbove + outsideMountAboveEighths;
                                    sessionStorage.setItem('_fit_finder_extension', outsideExtensionTotal);
                                    sessionStorage.setItem('_fit_finder_mountTotal', outsideMountTotal);

                                    // Grab the Go Back variables, and display depending on what they're set as. If they aren't set go to the collection for this product type
                                    var goBack = sessionStorage.getItem('_pb_goback');
                                    var goBackURL = sessionStorage.getItem('_pb_basepage');

                                    if (goBack === 'desktop-step-5-blinds') {
                                        $('.goback').html("<a type='button' class='fabric-choices call-to-action' href='" + goBackURL + "'>Customize Your Product</a>");
                                        // Set a Came From variable so we know what to show if we're going back to the product
                                        sessionStorage.setItem('_pb_camefrom', "fit-finder");
                                    } else {
                                        $('.goback').html("<a type='button' class='fabric-choices call-to-action' href='/collections/roman-shades/'>Customize Your Product</a>");
                                    }

                                    $('.step4-shades-outside').fadeOut(400, function () {
                                        $('.summary').fadeIn(400);
                                    });

                                    // Set loading bar default to 100%
                                    var bar1 = new ldBar(".ldBar", {
                                        "stroke": '#078578',
                                        "stroke-trail": '#ffffff',
                                        "aspect-ratio": 'none',
                                        "preset": 'line',
                                        "value": 10,
                                        "duration": 1,
                                    });
                                    bar1.set(100);

                                    // CALCULATE THE SIZE FOR THE SUMMARY
                                    // Shade Width = Width of the window + 2 X How far shade will extend past window frame
                                    // Shade Height = Height of window + How far above window the shade will be mounted
                                    var shadeWidth = outsideMountWidth + (2 * outsideExtensionTotal);
                                    var shadeHeight = outsideMountHeight + outsideMountTotal;
                                    var width1 = firstNumber(shadeWidth);
                                    var width2 = convertDecimal(shadeWidth);
                                    var height1 = firstNumber(shadeHeight);
                                    var height2 = convertDecimal(shadeHeight);

                                    $('#inside-measurements').html(width1 + " " + width2 + '" Width x ' + height1 + " " + height2 + '" Height');
                                    $('.product-style').html(mountType);
                                    $('.product-type').html(style);

                                    // Set a local storage variable including the measurement finals
                                    sessionStorage.setItem('_fit_finder_final_width', shadeWidth);
                                    sessionStorage.setItem('_fit_finder_final_height', shadeHeight);

                                    // Set the go back summary variable
                                    sessionStorage.setItem('_fit_finder_summary_goback', "step4-shades-outside");

                                    // Set a local storage variable for completing a fit finder
                                    sessionStorage.setItem('_fit_finder_complete', "complete");
                                }); // End final step/show summary
                            });
                        } // End outside mount
                    }); // End shade mount function
                }

                // DRAPES
                if (style === "drapes") {

                    $('.step1').fadeOut(400, function () {
                        $('.step2-drapes').fadeIn(400);
                    });

                    // Scroll to the top of the window
                    $("body").scrollTop(0);

                    // Set loading bar default to 100%
                    var bar1 = new ldBar(".ldBar", {
                        "stroke": '#078578',
                        "stroke-trail": '#ffffff',
                        "aspect-ratio": 'none',
                        "preset": 'line',
                        "value": 10,
                        "duration": 1,
                    });
                    bar1.set(25);

                    // Rod installed or not installed
                    $('.rod').change(function () {

                        // Set loading bar default to 35%
                        var bar1 = new ldBar(".ldBar", {
                            "stroke": '#078578',
                            "stroke-trail": '#ffffff',
                            "aspect-ratio": 'none',
                            "preset": 'line',
                            "value": 10,
                            "duration": 1,
                        });

                        bar1.set(35);
                        // Scroll to the top of the window
                        $("body").scrollTop(0);

                        var rodStatus = $('input[name=\'rod\']:checked').val();
                        sessionStorage.setItem('_fit_finder_rod_status', rodStatus);
                        // YES - Rod installed. Get rod length and height from bottom of rod to the floor
                        if (rodStatus === "true") {
                            $('.step2-drapes').fadeOut(400, function () {
                                $('.step3-drapes-rodtrue').fadeIn(400);
                            });

                            // Set loading bar default to 35%
                            var bar1 = new ldBar(".ldBar", {
                                "stroke": '#078578',
                                "stroke-trail": '#ffffff',
                                "aspect-ratio": 'none',
                                "preset": 'line',
                                "value": 10,
                                "duration": 1,
                            });

                            bar1.set(35);
                            $('.rod-measure-continue').click(function () {
                                var goBackStage = "step3-drapes-rodtrue";
                                sessionStorage.setItem('_fit_finder_panel_go_back', goBackStage);
                                rodWidthInches = parseFloat($('.drapes-rod-width-inches option:selected').val()) || 0;
                                rodWidthEighths = parseFloat($('.drapes-rod-width-eighths option:selected').val()) || 0;
                                rodHeightInches = parseFloat($('.drapes-rod-height-inches option:selected').val()) || 0;
                                rodHeightEighths = parseFloat($('.drapes-rod-height-eighths option:selected').val()) || 0;
                                rodWidthTotal = rodWidthInches + rodWidthEighths;
                                rodHeightTotal = rodHeightInches + rodHeightEighths;
                                sessionStorage.setItem('_fit_finder_rod_width', rodWidthTotal);
                                sessionStorage.setItem('_fit_finder_rod_height', rodHeightTotal);

                                $('.step3-drapes-rodtrue').fadeOut(400, function () {
                                    $('.panelnumber-drapes').fadeIn(400);
                                });

                                // Scroll to the top of the window
                                $("body").scrollTop(0);

                                // Set loading bar default to 65%
                                var bar1 = new ldBar(".ldBar", {
                                    "stroke": '#078578',
                                    "stroke-trail": '#ffffff',
                                    "aspect-ratio": 'none',
                                    "preset": 'line',
                                    "value": 10,
                                    "duration": 1,
                                });

                                bar1.set(65);
                                $('.panels').change(function () {
                                    var panelType = parseFloat($('input[name=\'panels\']:checked').val()) || 0;
                                    sessionStorage.setItem('_fit_finder_panel_type', panelType);
                                    // Scroll to the top of the window
                                    $("body").scrollTop(0);

                                    // Fall/drape style (Tailored, Lived In, Romantic)
                                    $('.panelnumber-drapes').fadeOut(400, function () {
                                        $('.fallstyle-drapes').fadeIn(400);
                                    });

                                    // Set loading bar default to 75%
                                    var bar1 = new ldBar(".ldBar", {
                                        "stroke": '#078578',
                                        "stroke-trail": '#ffffff',
                                        "aspect-ratio": 'none',
                                        "preset": 'line',
                                        "value": 10,
                                        "duration": 1,
                                    });

                                    bar1.set(75);


                                    $('.fallstyle').change(function () {
                                        var fallStyle = $('input[name=\'fallstyle\']:checked').val();
                                        if (fallStyle === "tailored") {
                                            var fallMeasurement = -1;
                                        }
                                        if (fallStyle === "lived-in") {
                                            var fallMeasurement = 0;
                                        }
                                        if (fallStyle === "romantic") {
                                            var fallMeasurement = 1;
                                        }

                                        sessionStorage.setItem('_fit_finder_fall_style', fallStyle);
                                        sessionStorage.setItem('_fit_finder_fall_measurement', fallMeasurement);

                                        // CALCULATE SIZE AND DISPLAY SUMMARY
                                        // width per panel = length of the curtain rod/# of panels (single =1, Double = 2)
                                        // Panel height = Height of the curtain rod to the floor + How drapes will fall (-1, 0,  or 1)
                                        var panelWidth = (rodWidthTotal/panelType);
                                        var panelHeight = rodHeightTotal + fallMeasurement;
                                        var width1 = firstNumber(panelWidth);
                                        var width2 = convertDecimal(panelWidth);
                                        var height1 = firstNumber(panelHeight);
                                        var height2 = convertDecimal(panelHeight);
                                        $('#inside-measurements').html(width1 + " " + width2 + '" Width x ' + height1 + " " + height2 + '" Height');
                                        $('.product-style').html(fallStyle);
                                        $('.product-type').html(style);

                                        // Set a local storage variable including the measurement finals
                                        sessionStorage.setItem('_fit_finder_final_width', panelWidth);
                                        sessionStorage.setItem('_fit_finder_final_height', panelHeight);

                                        // Scroll to the top of the window
                                        $("body").scrollTop(0);
                                        $('.fallstyle-drapes').fadeOut(400, function () {
                                            $('.summary').fadeIn(400);
                                        });

                                        // Set loading bar default to 100%
                                        var bar1 = new ldBar(".ldBar", {
                                            "stroke": '#078578',
                                            "stroke-trail": '#ffffff',
                                            "aspect-ratio": 'none',
                                            "preset": 'line',
                                            "value": 10,
                                            "duration": 1,
                                        });
                                        bar1.set(100);

                                        // Set the go back summary variable
                                        sessionStorage.setItem('_fit_finder_summary_goback', "fallstyle-drapes");

                                        // Set a local storage variable for completing a fit finder
                                        sessionStorage.setItem('_fit_finder_complete', "complete");

                                        // Grab the Go Back variables, and display depending on what they're set as. If they aren't set go to the collection for this product type
                                        var goBack = sessionStorage.getItem('_pb_goback');
                                        var goBackURL = sessionStorage.getItem('_pb_basepage');

                                        if (goBack === 'desktop-step-5-drapes') {
                                            $('.goback').html("<a type='button' class='fabric-choices call-to-action' href='" + goBackURL + "'>Customize Your Product</a>");
                                            // Set a Came From variable so we know what to show if we're going back to the product
                                            sessionStorage.setItem('_pb_camefrom', "fit-finder");
                                        } else {
                                            $('.goback').html("<a type='button' class='fabric-choices call-to-action' href='/collections/drapes/'>Customize Your Product</a>");
                                        }
                                    });
                                });

                            });
                        }
                        // NO - Rod not installed. Get window width, inches beyond window rod to extend, height from window top to floor, and inches above frame to mount the rod
                        if (rodStatus === "false") {
                            // Scroll to the top of the window
                            $("body").scrollTop(0);

                            $('.step2-drapes').fadeOut(400, function () {
                                $('.step4-drapes-window').fadeIn(400);
                            });

                            // Set loading bar default to 100%
                            var bar1 = new ldBar(".ldBar", {
                                "stroke": '#078578',
                                "stroke-trail": '#ffffff',
                                "aspect-ratio": 'none',
                                "preset": 'line',
                                "value": 10,
                                "duration": 1,
                            });

                            bar1.set(35);
                            // Measure the width of your window, how far the drapes will extend on either side
                            $('.drapes-window-extension-continue').click(function () {
                                drapeWindowWidthInches = parseFloat($('.drapes-window-height option:selected').val()) || 0;
                                drapeWindowWidthEighths = parseFloat($('.drapes-window-height-eighths option:selected').val()) || 0;
                                drapeWindowWidthTotal = parseFloat(drapeWindowWidthInches) + parseFloat(drapeWindowWidthEighths);
                                sessionStorage.setItem('_fit_finder_drape_window_width', drapeWindowWidthTotal);
                                drapeWindowExtensionInches = $('.drapes-window-extension-inches option:selected').val() || 0;
                                drapeWindowExtensionEighths = $('.drapes-window-extension-eighths option:selected').val() || 0;
                                drapeWindowExtensionTotal = parseFloat(drapeWindowExtensionInches) + parseFloat(drapeWindowExtensionEighths);
                                sessionStorage.setItem('_fit_finder_drape_window_extension', drapeWindowExtensionTotal);

                                // Scroll to the top of the window
                                $("body").scrollTop(0);

                                // Fade in next step, then
                                $('.step4-drapes-window').fadeOut(400, function () {
                                    $('.drapes-window-frameheight').fadeIn(400);
                                });

                                // Set loading bar default to 100%
                                var bar1 = new ldBar(".ldBar", {
                                    "stroke": '#078578',
                                    "stroke-trail": '#ffffff',
                                    "aspect-ratio": 'none',
                                    "preset": 'line',
                                    "value": 10,
                                    "duration": 1,
                                });

                                bar1.set(45);

                              $('.drapes-window-frame-continue').click(function () {
                                var goBackStage = 'drapes-window-frameheight';
                                sessionStorage.setItem('_fit_finder_panel_go_back', goBackStage);
                                // Measure from the top of the window frame to the floor
                                var drapeWindowTopInches = parseFloat($('.drapes-window-frame-height-inches option:selected').val()) || 0;
                                var drapeWindowTopEighths = parseFloat($('.drapes-window-frame-height-eighths option:selected').val()) || 0;
                                var drapeWindowTopTotal = parseFloat(drapeWindowTopInches) + parseFloat(drapeWindowTopEighths);
                                sessionStorage.setItem('_fit_finder_drape_window_top', drapeWindowTopTotal);
                                var rodMountHeightInches = parseFloat($('.drapes-rod-mount-height-inches option:selected').val()) || 0;
                                var rodMountHeightEighths = parseFloat($('.drapes-rod-mount-height-eighths option:selected').val()) || 0;
                                var rodMountHeightTotal = parseFloat(rodMountHeightInches) + parseFloat(rodMountHeightEighths);
                                sessionStorage.setItem('_fit_finder_rod_mount_height', rodMountHeightTotal);

                                // Scroll to the top of the window
                                $("body").scrollTop(0);

                                // Rod mount height
                                $('.drapes-window-frameheight').fadeOut(400, function () {
                                  //$('.step3-drapes-rodfalse').fadeIn(400);
                                  $('.panelnumber-drapes').fadeIn(400);
                                });

                                // Set loading bar default to 100%
                                var bar1 = new ldBar(".ldBar", {
                                  "stroke": '#078578',
                                  "stroke-trail": '#ffffff',
                                  "aspect-ratio": 'none',
                                  "preset": 'line',
                                  "value": 10,
                                  "duration": 1,
                                });

                                //bar1.set(55);
                                bar1.set(65);

                              });

                              $('.rod-mount-height-continue').click(function () {
                                var goBackStage = 'step3-drapes-rodfalse';
                                sessionStorage.setItem('_fit_finder_panel_go_back', goBackStage);
                                var rodMountHeightInches = parseFloat($('.drapes-rod-mount-height-inches option:selected').val()) || 0;
                                var rodMountHeightEighths = parseFloat($('.drapes-rod-mount-height-eighths option:selected').val()) || 0;
                                var rodMountHeightTotal = parseFloat(rodMountHeightInches) + parseFloat(rodMountHeightEighths);
                                sessionStorage.setItem('_fit_finder_rod_mount_height', rodMountHeightTotal);

                                // Scroll to the top of the window
                                $("body").scrollTop(0);

                                $('.step3-drapes-rodfalse').fadeOut(400, function () {
                                  $('.panelnumber-drapes').fadeIn(400);
                                });

                                // Set loading bar default to 100%
                                var bar1 = new ldBar(".ldBar", {
                                  "stroke": '#078578',
                                  "stroke-trail": '#ffffff',
                                  "aspect-ratio": 'none',
                                  "preset": 'line',
                                  "value": 10,
                                  "duration": 1,
                                });

                                bar1.set(65);
                              });

                              $('.panels').change(function () {
                                var panelType = parseFloat($('input[name=\'panels\']:checked').val()) || 0;
                                sessionStorage.setItem('_fit_finder_panel_type', panelType);

                                // Scroll to the top of the window
                                $("body").scrollTop(0);

                                // Fall/drape style (Tailored, Lived In, Romantic)
                                $('.panelnumber-drapes').fadeOut(400, function () {
                                  $('.fallstyle-drapes').fadeIn(400);
                                });

                                // Set loading bar default to 100%
                                var bar1 = new ldBar(".ldBar", {
                                  "stroke": '#078578',
                                  "stroke-trail": '#ffffff',
                                  "aspect-ratio": 'none',
                                  "preset": 'line',
                                  "value": 10,
                                  "duration": 1,
                                });

                                bar1.set(85);
                              });

                              $('.fallstyle').change(function () {
                                var fallStyle = $('input[name=\'fallstyle\']:checked').val();
                                var panelType = parseFloat($('input[name=\'panels\']:checked').val()) || 0;
                                if (fallStyle === "tailored") {
                                  var fallMeasurement = -1;
                                }
                                if (fallStyle === "lived-in") {
                                  var fallMeasurement = 0;
                                }
                                if (fallStyle === "romantic") {
                                  var fallMeasurement = 1;
                                }

                                sessionStorage.setItem('_fit_finder_fall_style', fallStyle);
                                sessionStorage.setItem('_fit_finder_fall_measurement', fallMeasurement);

                                // CALCULATE SIZE AND DISPLAY SUMMARY
                                // Width per panel =  (Width of window + 2 X How far drapes will extend past the window) /# of panels (single =1, Double = 2)
                                // Panel Height = Height from top of window to the floor + height from top of window to where rod will be mounted + How  drapes will fall (-1, x`0, or 1)
                                var drapeWindowTopTotal = parseFloat(sessionStorage.getItem('_fit_finder_drape_window_top'));
                                var drapeWindowWidthTotal = parseFloat(sessionStorage.getItem('_fit_finder_drape_window_width'));
                                var rodMountHeightTotal = parseFloat(sessionStorage.getItem('_fit_finder_rod_mount_height'));
                                var drapeWindowExtensionTotal = parseFloat(sessionStorage.getItem('_fit_finder_drape_window_extension'));
                                var panelWidth = ((drapeWindowWidthTotal + (2 * drapeWindowExtensionTotal))/panelType);
                                var panelHeight = drapeWindowTopTotal + rodMountHeightTotal + (fallMeasurement);
                                var width1 = firstNumber(panelWidth);
                                var width2 = convertDecimal(panelWidth);
                                var height1 = firstNumber(panelHeight);
                                var height2 = convertDecimal(panelHeight);
                                $('#inside-measurements').html(width1 + " " + width2 + '" Width x ' + height1 + " " + height2 + '" Height');
                                $('.product-style').html(fallStyle);
                                $('.product-type').html(style);

                                // Set a local storage variable including the measurement finals
                                sessionStorage.setItem('_fit_finder_final_width', panelWidth);
                                sessionStorage.setItem('_fit_finder_final_height', panelHeight);

                                // Scroll to the top of the window
                                $("body").scrollTop(0);

                                $('.fallstyle-drapes').fadeOut(400, function () {
                                  $('.summary').fadeIn(400);
                                });


                                // Set loading bar default to 100%
                                var bar1 = new ldBar(".ldBar", {
                                  "stroke": '#078578',
                                  "stroke-trail": '#ffffff',
                                  "aspect-ratio": 'none',
                                  "preset": 'line',
                                  "value": 10,
                                  "duration": 1,
                                });

                                bar1.set(100);

                                // Set the go back summary variable
                                sessionStorage.setItem('_fit_finder_summary_goback', "fallstyle-drapes");

                                // Set a local storage variable for completing a fit finder
                                sessionStorage.setItem('_fit_finder_complete', "complete");

                                // Grab the Go Back variables, and display depending on what they're set as. If they aren't set go to the collection for this product type
                                var goBack = sessionStorage.getItem('_pb_goback');
                                var goBackURL = sessionStorage.getItem('_pb_basepage');

                                // Go back
                                if (goBack === 'desktop-step-5-drapes') {
                                  $('.goback').html("<a type='button' class='fabric-choices call-to-action' href='" + goBackURL + "'>Customize Your Product</a>");
                                  // Set a Came From variable so we know what to show if we're going back to the product
                                  sessionStorage.setItem('_pb_camefrom', "fit-finder");
                                } else {
                                  $('.goback').html("<a type='button' class='fabric-choices call-to-action' href='/collections/drapes/'>Customize Your Product</a>");
                                }
                              }); // Fall style
                            });
                        } // End no rod
                    });
                }
            });
        } // End pre-selected
    }

    else {
        // Scroll to the top of the window
        $( "body" ).scrollTop( 0 );

        // Grab the Go Back variables, and display depending on what they're set as. If they aren't set go to the collection for this product type
        var goBack = sessionStorage.getItem('_pb_goback');
        var goBackURL = sessionStorage.getItem('_pb_basepage');

        // Get the base style
        var baseStyle = sessionStorage.getItem('_fit_finder_style');

      if (baseStyle === "shades") {
        if (goBack === 'desktop-step-5-blinds') {
          $('.goback').html("<a type='button' class='fabric-choices call-to-action' href='" + goBackURL + "'>Customize Your Product</a>");
          // Set a Came From variable so we know what to show if we're going back to the product
          sessionStorage.setItem('_pb_camefrom',"fit-finder");
          $('.summary').fadeIn(800);
          // Set loading bar default to 100%
          var bar1 = new ldBar(".ldBar", {
            "stroke": '#078578',
            "stroke-trail": '#ffffff',
            "aspect-ratio": 'none',
            "preset": 'line',
            "value": 10,
            "duration": 1,
          });

          bar1.set(100);
        }
        else {
          if (goBack === 'desktop-step-5-drapes') {
            clearFitFinder();
            // Scroll to the top of the window
            $( "body" ).scrollTop( 0 );
            $('input[name=\'shades-mount\']').prop('checked', false);
            $('input[name=\'style\']').prop('checked', false);
            $('input[name=\'rod\']').prop('checked', false);
            $('input[name=\'panels\']').prop('checked', false);
            $('input[name=\'fallstyle\']').prop('checked', false);
            $('.step2-drapes').fadeIn(800);
          }
          else if (goBack === 'mobile-measurements-readout') {
            $( "body" ).scrollTop( 0 );
            $('.step1').fadeIn(800);
          }
          else {
            clearFitFinder();
            $( "body" ).scrollTop( 0 );
            $('input[name=\'shades-mount\']').prop('checked', false);
            $('input[name=\'style\']').prop('checked', false);
            $('input[name=\'rod\']').prop('checked', false);
            $('input[name=\'panels\']').prop('checked', false);
            $('input[name=\'fallstyle\']').prop('checked', false);
            $('.step1').fadeIn(800);
          }
        }
      }

      if (baseStyle === "drapes") {
        if (goBack === 'desktop-step-5-drapes') {
          $('.goback').html("<a type='button' class='fabric-choices call-to-action' href='" + goBackURL + "'>Customize Your Product</a>");
          // Set a Came From variable so we know what to show if we're going back to the product
          sessionStorage.setItem('_pb_camefrom',"fit-finder");
          $('.summary').fadeIn(800);
          // Set loading bar default to 100%
          var bar1 = new ldBar(".ldBar", {
            "stroke": '#078578',
            "stroke-trail": '#ffffff',
            "aspect-ratio": 'none',
            "preset": 'line',
            "value": 10,
            "duration": 1,
          });

          bar1.set(100);
        }
        else {
          if (goBack === 'desktop-step-5-blinds') {
            // Scroll to the top of the window
            clearFitFinder();
            $( "body" ).scrollTop( 0 );
            $('input[name=\'shades-mount\']').prop('checked', false);
            $('input[name=\'style\']').prop('checked', false);
            $('input[name=\'rod\']').prop('checked', false);
            $('input[name=\'panels\']').prop('checked', false);
            $('input[name=\'fallstyle\']').prop('checked', false);
            $('.step2-shades').fadeIn(800);
          }
          else {
            clearFitFinder();
            $( "body" ).scrollTop( 0 );
            $('input[name=\'shades-mount\']').prop('checked', false);
            $('input[name=\'style\']').prop('checked', false);
            $('input[name=\'rod\']').prop('checked', false);
            $('input[name=\'panels\']').prop('checked', false);
            $('input[name=\'fallstyle\']').prop('checked', false);
            $('.step1').fadeIn(800);
          }
        }
      }
    }

    // If the start over button is clicked, reset all variables
  $('.start-over').click(function() {
    // Scroll to the top of the window
    $( "body" ).scrollTop( 0 );
    $('input[name=\'shades-mount\']').prop('checked', false);
    $('input[name=\'style\']').prop('checked', false);
    $('input[name=\'rod\']').prop('checked', false);
    $('input[name=\'panels\']').prop('checked', false);
    $('input[name=\'fallstyle\']').prop('checked', false);
    clearFitFinder();
    window.location.replace('/pages/fit-finder/');
  });

    // Going back to the previous step.
        // From Shades step 2 to Step 1
        $('.go-back-shades-mount').click(function(){
            $( '.step2-shades' ).fadeOut( 400, function(){
                $( '.step1' ).fadeIn( 400 );
            });
            $('input[name=\'style\']').prop('checked', false);
            // Set loading bar default to 100%
            var bar1 = new ldBar(".ldBar", {
                "stroke": '#078578',
                "stroke-trail": '#ffffff',
                "aspect-ratio": 'none',
                "preset": 'line',
                "value": 10,
                "duration": 1,
            });

            bar1.set(10);

            // Scroll to the top of the window
            $( "body" ).scrollTop( 0 );
         });

        // step3-shades-inside to step2-shades
        $('.go-back-shades-inside-mount').click(function() {
            $( '.step3-shades-inside' ).fadeOut( 400, function(){
                $( '.step2-shades' ).fadeIn( 400 );
            });
            $('input[name=\'shades-mount\']').prop('checked', false);
            // Set loading bar default to 100%
            var bar1 = new ldBar(".ldBar", {
                "stroke": '#078578',
                "stroke-trail": '#ffffff',
                "aspect-ratio": 'none',
                "preset": 'line',
                "value": 10,
                "duration": 1,
            });

            bar1.set(25);

            // Scroll to the top of the window
            $( "body" ).scrollTop( 0 );
        });

        // step3-shades-outside to step2-shades
        $('.go-back-shades-outside-mount').click(function() {
            $( '.step3-shades-outside' ).fadeOut( 400, function(){
                $( '.step2-shades' ).fadeIn( 400 );
            });
            $('input[name=\'shades-mount\']').prop('checked', false);

            // Set loading bar default to 100%
            var bar1 = new ldBar(".ldBar", {
                "stroke": '#078578',
                "stroke-trail": '#ffffff',
                "aspect-ratio": 'none',
                "preset": 'line',
                "value": 10,
                "duration": 1,
            });

            bar1.set(25);

            // Scroll to the top of the window
            $( "body" ).scrollTop( 0 );
        });

        // step4-shades-outside to step3-shades-outside
        $('.go-back-shades-outside-mount-additional').click(function() {
            $( '.step4-shades-outside' ).fadeOut( 400, function(){
                $( '.step3-shades-outside' ).fadeIn( 400 );
            });

            // Set loading bar default to 100%
            var bar1 = new ldBar(".ldBar", {
                "stroke": '#078578',
                "stroke-trail": '#ffffff',
                "aspect-ratio": 'none',
                "preset": 'line',
                "value": 10,
                "duration": 1,
            });

            bar1.set(50);

            // Scroll to the top of the window
            $( "body" ).scrollTop( 0 );
        });

        // From drapes step 2 to Step 1
        $('.go-back-drapes').click(function(){
            $( '.step2-drapes' ).fadeOut( 400, function(){
                $( '.step1' ).fadeIn( 400 );
            });

            $('input[name=\'style\']').prop('checked', false);

            // Set loading bar default to 100%
            var bar1 = new ldBar(".ldBar", {
                "stroke": '#078578',
                "stroke-trail": '#ffffff',
                "aspect-ratio": 'none',
                "preset": 'line',
                "value": 10,
                "duration": 1,
            });

            bar1.set(10);

            // Scroll to the top of the window
            $( "body" ).scrollTop( 0 );
        });

        // rod status to drapes step 2
        $('.go-back-rod-measure').click(function() {
            $( '.step3-drapes-rodtrue' ).fadeOut( 400, function(){
                $( '.step2-drapes' ).fadeIn( 400 );
            });

            $('input[name=\'rod\']').prop('checked', false);

            //remove stored variable
            sessionStorage.removeItem('_fit_finder_panel_go_back');

            // Set loading bar default to 100%
            var bar1 = new ldBar(".ldBar", {
                "stroke": '#078578',
                "stroke-trail": '#ffffff',
                "aspect-ratio": 'none',
                "preset": 'line',
                "value": 10,
                "duration": 1,
            });

            bar1.set(25);
            // Scroll to the top of the window
            $( "body" ).scrollTop( 0 );
        });

        // rod not installed to drapes step 2
        $('.go-back-rod-mount').click(function() {
            $( '.step3-drapes-rodfalse' ).fadeOut( 400, function(){
                $( '.drapes-window-frameheight' ).fadeIn( 400 );
            });

            $('input[name=\'rod\']').prop('checked', false);

            //remove stored variable
            sessionStorage.removeItem('_fit_finder_panel_go_back');

            // Set loading bar default to 100%
            var bar1 = new ldBar(".ldBar", {
                "stroke": '#078578',
                "stroke-trail": '#ffffff',
                "aspect-ratio": 'none',
                "preset": 'line',
                "value": 10,
                "duration": 1,
            });

            bar1.set(35);

            // Scroll to the top of the window
            $( "body" ).scrollTop( 0 );
        });

        // frameheight to step4-drapes-window
        $('.go-back-frame-height').click(function() {
            $( '.drapes-window-frameheight' ).fadeOut( 400, function(){
                $( '.step4-drapes-window' ).fadeIn( 400 );
            });

            // Set loading bar default to 100%
            var bar1 = new ldBar(".ldBar", {
                "stroke": '#078578',
                "stroke-trail": '#ffffff',
                "aspect-ratio": 'none',
                "preset": 'line',
                "value": 10,
                "duration": 1,
            });

            bar1.set(35);

            // Scroll to the top of the window
            $( "body" ).scrollTop( 0 );
        });

        //step4-drapes-window back to rod status
        $('.go-back-drape-measure-mount').click(function() {
            $( '.step4-drapes-window' ).fadeOut( 400, function(){
                $( '.step2-drapes' ).fadeIn( 400 );
            });

            // unselect
            $('input[name=\'rod\']').prop('checked', false);

            // Set loading bar default to 100%
            var bar1 = new ldBar(".ldBar", {
                "stroke": '#078578',
                "stroke-trail": '#ffffff',
                "aspect-ratio": 'none',
                "preset": 'line',
                "value": 10,
                "duration": 1,
            });

            bar1.set(25);

            // Scroll to the top of the window
            $( "body" ).scrollTop( 0 );
        });


        // Go back from panels. Get the local variable for style to see where to go back to.
        $('.go-back-panels').click(function() {
            $('input[name=\'fallstyle\']').prop('checked', false);
           var goBackStage = sessionStorage.getItem('_fit_finder_panel_go_back');
            $( '.panelnumber-drapes' ).fadeOut( 400, function(){
                $( '.'+goBackStage ).fadeIn( 400 );
            });

            // Set loading bar default to 100%
            var bar1 = new ldBar(".ldBar", {
                "stroke": '#078578',
                "stroke-trail": '#ffffff',
                "aspect-ratio": 'none',
                "preset": 'line',
                "value": 10,
                "duration": 1,
            });

            bar1.set(45);

            // Scroll to the top of the window
            $( "body" ).scrollTop( 0 );
        });

        // From hanging style to panels
        $('.go-back-fallstyle').click(function() {
            $('input[name=\'panels\']').prop('checked', false);
            $( '.fallstyle-drapes' ).fadeOut( 400, function(){
                $( '.panelnumber-drapes' ).fadeIn( 400 );
            });

            // Set loading bar default to 100%
            var bar1 = new ldBar(".ldBar", {
                "stroke": '#078578',
                "stroke-trail": '#ffffff',
                "aspect-ratio": 'none',
                "preset": 'line',
                "value": 10,
                "duration": 1,
            });

            bar1.set(55);

            // Scroll to the top of the window
            $( "body" ).scrollTop( 0 );
        });

        // Go back from the summary; collect a local variable to determine where to go back to
        $('.go-back-summary').click(function() {
            $('input[name=\'fallstyle\']').prop('checked', false);
            var goBackStage = sessionStorage.getItem('_fit_finder_summary_goback');
            sessionStorage.removeItem('_fit_finder_complete');

            $( '.summary' ).fadeOut( 400, function(){
                $( '.'+goBackStage ).fadeIn( 400 );
            });

            // Set loading bar default to 100%
            var bar1 = new ldBar(".ldBar", {
                "stroke": '#078578',
                "stroke-trail": '#ffffff',
                "aspect-ratio": 'none',
                "preset": 'line',
                "value": 10,
                "duration": 1,
            });

            bar1.set(75);

            // Scroll to the top of the window
            $( "body" ).scrollTop( 0 );

        });


    // Function to convert the decimals into fractions
    function convertDecimal(number) {
        var fullNumber = parseFloat(number);
        var decimal = fullNumber - Math.floor(fullNumber);
        var final = "";

        if (decimal === 0.00) {
            final = "";
        }
        else if (decimal === 0.125) {
            final = "1/8";
        }
        else if (decimal === 0.25) {
            final = "1/4";
        }
        else if (decimal === 0.375) {
            final = "3/8";
        }
        else if (decimal === 0.5) {
            final = "1/2";
        }
        else if (decimal === 0.625) {
            final = "5/8";
        }
        else if (decimal === 0.75) {
            final = "3/4";
        }
        else if (decimal === 0.875) {
            final = "7/8";
        }
        else {
            final = decimal;
        }

        return final;
    };

    function firstNumber(number) {
        var fullNumber = Math.floor(number);
        return fullNumber;
    };

  
  function clearFitFinder() {
     sessionStorage.removeItem('_fit_finder_complete');
     sessionStorage.removeItem('_fit_finder_style');
     sessionStorage.removeItem('_fit_finder_rod_status');
     sessionStorage.removeItem('_fit_finder_panel_go_back');
     sessionStorage.removeItem('_fit_finder_rod_width');
     sessionStorage.removeItem('_fit_finder_rod_height');
     sessionStorage.removeItem('_fit_finder_panel_type');
     sessionStorage.removeItem('_fit_finder_fall_style');
     sessionStorage.removeItem('_fit_finder_fall_measurement');
     sessionStorage.removeItem('_fit_finder_final_width');
     sessionStorage.removeItem('_fit_finder_final_height');
     sessionStorage.removeItem('_fit_finder_summary_goback');
     sessionStorage.removeItem('_fit_finder_drape_window_width');
     sessionStorage.removeItem('_fit_finder_drape_window_extension');
     sessionStorage.removeItem('_fit_finder_drape_window_top');
     sessionStorage.removeItem('_fit_finder_rod_mount_height');
     sessionStorage.removeItem('_fit_finder_mountType');
     sessionStorage.removeItem('_fit_finder_height');
     sessionStorage.removeItem('_fit_finder_width');
     sessionStorage.removeItem('_fit_finder_extension');
     sessionStorage.removeItem('_fit_finder_mountTotal');
  }
});
